import { render, staticRenderFns } from "./engine-oil-recommend.vue?vue&type=template&id=f8a33bbc&scoped=true&"
import script from "./engine-oil-recommend.vue?vue&type=script&lang=js&"
export * from "./engine-oil-recommend.vue?vue&type=script&lang=js&"
import style0 from "./engine-oil-recommend.vue?vue&type=style&index=0&id=f8a33bbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a33bbc",
  null
  
)

export default component.exports